module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-361.1d53d5a.woff2";